var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n      }\n\n      .cls-2 {\n        fill: #717402;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logout",
    transform: "translate(-694 1011)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_70",
    "data-name": "Rectangle 70",
    className: "cls-1",
    width: 200,
    height: 200,
    transform: "translate(694 -1011)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-log-out",
    "data-name": "Icon feather-log-out",
    transform: "translate(698 -1007)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_115",
    "data-name": "Path 115",
    className: "cls-2",
    d: "M65.278,196H24.315A28.347,28.347,0,0,1-4,167.685V24.315A28.315,28.315,0,0,1,24.315-4H65.278a7.834,7.834,0,0,1,0,15.668H24.315A12.647,12.647,0,0,0,11.668,24.315V167.685a12.662,12.662,0,0,0,12.647,12.647H65.278a7.834,7.834,0,0,1,0,15.668Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_116",
    "data-name": "Path 116",
    className: "cls-2",
    d: "M23.334,120.075a7.834,7.834,0,0,1-5.54-13.374L63.458,61.037,17.795,15.374A7.834,7.834,0,0,1,28.874,4.295l51.2,51.2a7.834,7.834,0,0,1,0,11.079l-51.2,51.2A7.81,7.81,0,0,1,23.334,120.075Z",
    transform: "translate(113.629 34.963)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117",
    "data-name": "Path 117",
    className: "cls-2",
    d: "M135.722,25.168H12.834a7.834,7.834,0,1,1,0-15.668H135.722a7.834,7.834,0,1,1,0,15.668Z",
    transform: "translate(52.444 78.666)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.7f1cdc52847ec58b9c87ce5392676e9f.svg";
export { ForwardRef as ReactComponent };